import uk from '@/data/i18n/uk.json'

Object.byString = function(o, s) {
  s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  s = s.replace(/^\./, '');           // strip a leading dot
  var a = s.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
      var k = a[i];
      if (k in o) {
          o = o[k];
      } else {
          return;
      }
  }
  return o;
}

const snippets = {
  replace: function (snippet, item, val) {
    let rgx = new RegExp('\\$\\{' + item + '\\}')
    let snip = Object.byString(this, snippet)
    return snip.replace(rgx, val)
  }
}

Object.assign(snippets, uk)

export default snippets